
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/personal-licenses",
      function () {
        return require("private-next-pages/terminal/personal-licenses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/personal-licenses"])
      });
    }
  